// extracted by mini-css-extract-plugin
export default {"result":"ResultComponent_result__OsRht","icon":"ResultComponent_icon__8lkkf","buttons":"ResultComponent_buttons__StlcP"};